import React, { useRef, useEffect, useState } from "react";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import Logo from "../assets/images/Logo.svg";
import { NavLink } from "react-router-dom";
import useOnClickOutside from "../hooks/useOnClickOutside";
// import {
//   getOrganizationProfileById,
//   getOrganizatonMetricsById,
//   getRiskProfile,
// } from "../redux/actions/organizationProfileCreators";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PriorityHighRoundedIcon from "@mui/icons-material/PriorityHighRounded";
import ManagementIcon from "../assets/sidebarIcons/ManagementIcon";
import OrgaProfileIcon from "../assets/sidebarIcons/OrgaProfileIcon";
import UsersIcon from "../assets/sidebarIcons/UsersIcon";
import ReportIcon from "../assets/sidebarIcons/ReportIcon";
// import RisksIcon from "../assets/sidebarIcons/RisksIcon";
import AssetsIcon from "../assets/sidebarIcons/AssetsIcon";
// import WeaknessesIcon from "../assets/sidebarIcons/WeaknessesIcon";
// import UseCasesIcon from "../assets/sidebarIcons/UseCasesIcon";
import OrgaSelectedControl from "./OrgaSelectedControl";
// import RiskProfileIcon from "./icons/RiskProfileIcon";
import RiskProfileControl from "./RiskProfileControl";
// import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import AssignmentIcon from "@mui/icons-material/Assignment";
import RemoveModeratorIcon from "@mui/icons-material/RemoveModerator";
import PolicyIcon from "@mui/icons-material/Policy";
import WarningIcon from "@mui/icons-material/Warning";

const Sidebar = ({ isMobile, isOpen, toggleAside }) => {
  const storedUser = localStorage.getItem("user");
  // const language = localStorage.getItem("i18nextLng");
  const webApp = useSelector((state) => state.organizationProfile.webApp);
  const profileRole = useSelector((state) => state.user?.profile?.role);
  // const completedQuizzes = useSelector(
  //   (state) => state.organizationProfile.completedQuizzes
  // );
  // const completedThreatQuizzes = useSelector(
  //   (state) => state.organizationProfile.completedThreatQuizzes
  // );
  const id = useSelector((state) => state.organizationProfile.id);
  const profile = useSelector(
    (state) => state.organizationProfile.organizationMetricsById
  );

  // const dispatch = useDispatch();
  // const orgaId = localStorage.getItem("orgaId");
  const [open, setOpen] = useState(false);
  const [openRisk, setOpenRisk] = useState(false);
  const [currentOrga, setCurrentOrga] = useState({});
  const asideRef = useRef();
  const { t } = useTranslation();
  useOnClickOutside(asideRef, isMobile && isOpen ? toggleAside : () => null);
  const normalizeWorkflowStatus = (rawValue) => {
    const value = String(rawValue ?? "").trim().toLowerCase();
    if (value === "in_progress") {
      return "in_progress";
    }
    if (value === "not_started") {
      return "not_started";
    }
    if (value === "failure") {
      return "failed";
    }
    return value;
  };
  const normalizeActiveReport = (rawValue) =>
    String(rawValue ?? "").trim().toLowerCase();

  const activeReport = normalizeActiveReport(profile?.active_report);
  const generateReportStatus = normalizeWorkflowStatus(profile?.generate_report_status);
  const reconnaissanceStatus = normalizeWorkflowStatus(profile?.reconnaissance_status);
  const assetsDiscoveryStatus = normalizeWorkflowStatus(profile?.assets_discovery_status);
  const riskScenariosStatus = normalizeWorkflowStatus(profile?.risk_scenarios_status);
  const riskAssessmentStatus = normalizeWorkflowStatus(profile?.risk_assesment_status);

  const isFlashReportActive = activeReport === "flash_report";
  const isRiskReportActive = activeReport === "risk_report";
  const isCompleted = (status) => status === "completed";
  const hasCompletedReports = Boolean(profile?.has_completed_reports);

  // Access policy:
  // - Flash report active blocks all pages except Reports.
  // - Evaluation is always accessible when risk report is active.
  // - Other pages are enabled when their associated phase is completed.
  // - Reports page is enabled by a completed generate_report or existing report artifacts.
  const isEvaluationEnabled = !!id && !isFlashReportActive && isRiskReportActive;
  const isBusinessFunctionEnabled =
    !!id && !isFlashReportActive && isCompleted(reconnaissanceStatus);
  const isDiscoveredAssetsEnabled =
    !!id && !isFlashReportActive && isCompleted(assetsDiscoveryStatus);
  const isRiskScenariosEnabled =
    !!id && !isFlashReportActive && isCompleted(riskScenariosStatus);
  const isRiskAssessmentEnabled =
    !!id && !isFlashReportActive && isCompleted(riskAssessmentStatus);
  const isOrgaProfileEnabled =
    !!id && !isFlashReportActive && isCompleted(reconnaissanceStatus);

  // const isReportEnabled = !!id && isCompleted(generateReportStatus);

  const isReportEnabled =
    !!id && (isCompleted(generateReportStatus) || hasCompletedReports);
  
  // const history = useHistory();
  // const location = useLocation();
  // const isActive = location.pathname.startsWith("/risk_profile");

  // useEffect(() => {
  //   if (
  //     id &&
  //     id !== "null" &&
  //     (JSON.parse(storedUser).role === "enterprise_admin" ||
  //       JSON.parse(storedUser).role === "cytailor_admin")
  //   ) {
  //     dispatch(getOrganizatonMetricsById(id));
  //   }
  // }, [dispatch, id]);

  useEffect(() => {
    if (id && profile && Object.keys(profile)?.length > 0) {
      setCurrentOrga(profile);
      console.log("Current Orga set:", profile);
    }
  }, [id, profile]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (event) => {
    if (JSON.parse(storedUser).account_type === "enterprise") {
      if (!id) {
        event.preventDefault();
        setOpen(true);
      } else {
        toggleAside();
      }
    } else {
      toggleAside();
    }
  };

  // const handleRiskProfileClick = async (event) => {
  //   const accountType = JSON.parse(storedUser)?.account_type;
  //   if ((accountType === "enterprise" && !id) || accountType !== "enterprise") {
  //     event.preventDefault();
  //     setOpen(true);
  //   } else {
  //     event.preventDefault();
  //     try {
  //       id !== null && history.push(`/risk_profile`);
  //     } catch (error) {
  //       if (error?.response?.status === 403) {
  //         setOpen(true);
  //       }
  //     }
  //   }
  // };

  return (
    <div
      ref={asideRef}
      className={`sidebar ${isMobile ? "mobile" : ""} ${isOpen ? "open" : ""}`}
      style={{
        height: "100vh",
        minWidth: "280px",
        display: "flex", // Enable flexbox for vertical layout
        flexDirection: "column", // Stack children vertically
      }}
    >
      <OrgaSelectedControl
        open={open}
        handleClose={handleClose}
        type={
          JSON.parse(storedUser).role === "admin" ||
          JSON.parse(storedUser).role === "enterprise_user"
            ? "not_completed"
            : id && currentOrga
            ? "not_completed"
            : "not_selected"
        }
      />
      <RiskProfileControl
        open={openRisk}
        handleClose={() => setOpenRisk(false)}
      />
      <div style={{ position: "relative" }}>
        <img
          src={Logo}
          width="70%"
          height="76.58"
          style={{ padding: "40px" }}
          alt=""
        />
        {isMobile && isOpen && (
          <ArrowCircleLeftIcon
            onClick={toggleAside}
            style={{
              position: "absolute",
              top: "50%",
              transform: "translateY(-50%)",
              right: -11,
              color: "#78c3ae",
            }}
          />
        )}
      </div>
      {JSON.parse(storedUser).account_type === "enterprise" ? (
        <ul
          style={{
            margin: "auto", // Keep original centering
            padding: 0, // Keep original padding
            flexGrow: 1, // Take up remaining vertical space
            overflowY: "auto", // Enable vertical scrolling
            maxHeight: "calc(100vh - 156.58px)", // Limit height for scrolling
          }}
          id={isMobile && isOpen ? "sidebar-scroll" : ""}
        >
          {profileRole === "cytailor_admin" && (
            <>
              <li style={{ padding: "10px 0px" }}>
                <NavLink
                  to="/super_admin_management"
                  className="nav"
                  activeClassName="isActive"
                  onClick={toggleAside}
                >
                  <ManagementIcon></ManagementIcon>
                  <span
                    className="nav-title"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    Management
                  </span>
                </NavLink>
              </li>
            </>
          )}
          {(JSON.parse(storedUser).role === "enterprise_admin" ||
            JSON.parse(storedUser).role === "cytailor_admin") && (
            <>
              <li style={{ padding: "10px 0px" }}>
                <NavLink
                  to="/enterprise"
                  className="nav"
                  activeClassName="isActive"
                  onClick={toggleAside}
                >
                  <OrgaProfileIcon></OrgaProfileIcon>
                  <span
                    className="nav-title"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    {t("enterprise")}
                  </span>
                </NavLink>
              </li>
            </>
          )}
          <li style={{ padding: "10px 0px" }}>
            <NavLink
              to="/users"
              className="nav"
              activeClassName="isActive"
              onClick={toggleAside}
            >
              <UsersIcon></UsersIcon>
              <span className="nav-title">{t("users_roles")}</span>
            </NavLink>
          </li>
          {/* <li style={{ padding: "10px 0px" }}>
            <NavLink
              to="/risk"
              className="nav"
              activeClassName="isActive"
              onClick={toggleAside}
            >
              <RisksIcon></RisksIcon>
              <span className="nav-title">{t("risks")}</span>
            </NavLink>
          </li> */}
          {/* <li style={{ padding: "10px 0px" }}>
            <NavLink
              to="/weakness"
              className="nav"
              activeClassName="isActive"
              onClick={toggleAside}
            >
              <WeaknessesIcon></WeaknessesIcon>
              <span className="nav-title">{t("weaknesses")}</span>
            </NavLink>
          </li> */}
          {/* <li style={{ padding: "10px 0px" }}>
            <NavLink
              to="/usecases"
              className="nav"
              activeClassName="isActive"
              onClick={toggleAside}
            >
              <UseCasesIcon></UseCasesIcon>
              <span className="nav-title">{t("usecases")}</span>
            </NavLink>
          </li> */}
          {/* <li style={{ padding: "10px 0px" }}>
            <NavLink
              to="/assets"
              className="nav"
              activeClassName="isActive"
              onClick={toggleAside}
            >
              <AssetsIcon></AssetsIcon>
              <span className="nav-title">{t("assets")}</span>
            </NavLink>
          </li> */}
          <hr style={{ border: "1px solid #669386", margin: "25px 0" }} />
          {/* <li style={{ padding: "10px 0px" }}>
            <div
              style={{ cursor: "pointer" }}
              className={`nav ${isActive ? "isActive" : ""}`}
              // onClick={(e) => handleRiskProfileClick(e)}
            >
              <RiskProfileIcon />
              <span
                className="nav-title"
                style={{ display: "flex", alignItems: "center" }}
              >
                {t("risk_profile_sidebar")}
                 {currentOrga?.completed_quizzes_number === 0 && (
                  <PriorityHighRoundedIcon style={{ height: "30px" }} />
                )} 
              </span>
            </div>
          </li> */}
          <li style={{ padding: "10px 0px" }}>
            <NavLink
              to={id !== null && "/profile"}
              className={`nav ${!isOrgaProfileEnabled ? "disabled" : ""}`}
              activeClassName="isActive"
              onClick={(e) => {
                if (id === null) {
                  e.preventDefault();
                  setOpen(true);
                  return;
                }
                if (!isOrgaProfileEnabled) {
                  e.preventDefault();
                  return;
                }
                toggleAside();
              }}
            >
              <OrgaProfileIcon></OrgaProfileIcon>
              <span
                className="nav-title"
                style={{ display: "flex", alignItems: "center" }}
              >
                {t("orga_profile_sidebar")}
                {webApp && (
                  <PriorityHighRoundedIcon style={{ height: "30px" }} />
                )}
              </span>
            </NavLink>
          </li>

          <li style={{ padding: "10px 0px" }}>
            {/* <NavLink
              to="/evaluation"
              className="nav"
              activeClassName="isActive"
              onClick={(e) => handleClick(e)}
            > */}
            <NavLink
              to="/evaluation"
              className={`nav ${!isEvaluationEnabled ? "disabled" : ""}`}
              activeClassName="isActive"
              onClick={(e) => {
                // no orga selected → keep your current behavior
                if (!id) {
                  e.preventDefault();
                  setOpen(true);
                  return;
                }

                // ✅ only enabled when active_report === "risk_report"
                if (!isEvaluationEnabled) {
                  e.preventDefault();
                  return;
                }

                handleClick(e);
              }}
            >
              <AssignmentIcon />
              <span className="nav-title">{t("evaluation")}</span>
            </NavLink>
          </li>

          {/* <li style={{ padding: "10px 0px" }}>
            <NavLink
              className="nav"
              activeClassName="isActive"
              to="/quizzes"
              onClick={(e) => handleClick(e)}
            >
              <QuizzIcon></QuizzIcon>
              <span
                className="nav-title"
                style={{ display: "flex", alignItems: "center" }}
              >
                {t("quizzes")}
              </span>
            </NavLink>
          </li> */}

          {/* <li style={{ padding: "10px 0px" }}>
            <NavLink
              to="/workstation"
              className="nav"
              activeClassName="isActive"
              onClick={(e) => handleClick(e)}
            >
              <HomeWorkIcon />
              <span className="nav-title">{t("workstation")}</span>
            </NavLink>
          </li> */}

          <li style={{ padding: "10px 0px" }}>
            <NavLink
              to="/reports"
              className={`nav ${!isReportEnabled ? "disabled" : ""}`}
              activeClassName="isActive"
              onClick={(e) => {
                if (!isReportEnabled) {
                  e.preventDefault();
                } else {
                  handleClick(e);
                }
              }}
            >
              <ReportIcon></ReportIcon>
              <span className="nav-title">{t("reports")}</span>
            </NavLink>
          </li>
          <li style={{ padding: "10px 0px" }}>
            <NavLink
              to="/orga_assets"
              className={`nav ${!isBusinessFunctionEnabled ? "disabled" : ""}`}
              activeClassName="isActive"
              onClick={(e) => {
                if (!isBusinessFunctionEnabled) {
                  e.preventDefault();
                } else {
                  handleClick(e);
                }
              }}
            >
              <AssetsIcon></AssetsIcon>
              <span className="nav-title">{t("business_function")}</span>
            </NavLink>
          </li>
          <li style={{ padding: "10px 0px" }}>
            <NavLink
              to="/asset_inventory"
              className={`nav ${!isDiscoveredAssetsEnabled ? "disabled" : ""}`}
              activeClassName="isActive"
              onClick={(e) => {
                if (!isDiscoveredAssetsEnabled) {
                  e.preventDefault();
                } else {
                  handleClick(e);
                }
              }}
            >
              <PolicyIcon />
              <span className="nav-title">{t("discovered_assets")}</span>
            </NavLink>
          </li>
          <li style={{ padding: "10px 0px" }}>
            <NavLink
              to="/risk-scenarios"
              className={`nav ${!isRiskScenariosEnabled ? "disabled" : ""}`}
              activeClassName="isActive"
              onClick={(e) => {
                if (!isRiskScenariosEnabled) {
                  e.preventDefault();
                } else {
                  handleClick(e);
                }
              }}
            >
              <WarningIcon />
              <span className="nav-title">{t("risk-scenarios")}</span>
            </NavLink>
          </li>
          <li style={{ padding: "10px 0px" }}>
            <NavLink
              to="/risk-assessment"
              className={`nav ${!isRiskAssessmentEnabled ? "disabled" : ""}`}
              activeClassName="isActive"
              onClick={(e) => {
                if (!isRiskAssessmentEnabled) {
                  e.preventDefault();
                } else {
                  handleClick(e);
                }
              }}
            >
              <RemoveModeratorIcon />
              <span className="nav-title">{t("risk-assessment")}</span>
            </NavLink>
          </li>
          {/* <li style={{ padding: "10px 0px" }}>
            <NavLink
              to="/asset_inventory"
              className="nav"
              activeClassName="isActive"
              onClick={(e) => handleClick(e)}
            >
              <RemoveModeratorIcon />
              <span className="nav-title">{t("threat_landscape")}</span>
            </NavLink>
          </li> */}
        </ul>
      ) : (
        <ul
          style={{
            width: "240px", // Keep original width
            margin: "auto", // Keep original centering
            padding: 0, // Keep original padding
            flexGrow: 1, // Take up remaining vertical space
            overflowY: "auto", // Enable vertical scrolling
            maxHeight: "calc(100vh - 156.58px)", // Limit height for scrolling
          }}
          id={isMobile && isOpen ? "sidebar-scroll" : ""}
        >
          {/* <li style={{ padding: "10px 0px" }}>
            <div
              style={{ cursor: "pointer" }}
              className={`nav ${isActive ? "isActive" : ""}`}
              // onClick={(e) => handleRiskProfileClick(e)}
            >
              <RiskProfileIcon />
              <span
                className="nav-title"
                style={{ display: "flex", alignItems: "center" }}
              >
                {t("risk_profile_sidebar")}
                {currentOrga?.completed_quizzes_number === 0 && (
                  <PriorityHighRoundedIcon style={{ height: "30px" }} />
                )} 
              </span>
            </div>
          </li> */}
          {/* <li style={{ padding: "10px 0px" }}>
            <NavLink
              className="nav"
              activeClassName="isActive"
              to="/quizzes"
              onClick={toggleAside}
            >
              <QuizzIcon></QuizzIcon>
              <span className="nav-title">{t("quizzes")}</span>
            </NavLink>
          </li> */}
          {/* <li style={{ padding: "10px 0px" }}>
            <NavLink
              to="/workstation"
              className="nav"
              activeClassName="isActive"
              onClick={(e) => handleClick(e)}
            >
              <ChatIcon />
              <span className="nav-title">{t("workstation")}</span>
            </NavLink>
          </li> */}
          {(JSON.parse(storedUser).role === "admin" ||
            JSON.parse(storedUser).role === "enterprise_user") && (
            <>
              <li style={{ padding: "10px 0px" }}>
                <NavLink
                  to="/profile"
                  className="nav"
                  activeClassName="isActive"
                  onClick={toggleAside}
                >
                  <OrgaProfileIcon></OrgaProfileIcon>
                  <span
                    className="nav-title"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    {t("orga_profile_sidebar")}
                    {webApp && (
                      <PriorityHighRoundedIcon style={{ height: "30px" }} />
                    )}
                  </span>
                </NavLink>
              </li>
              <li style={{ padding: "10px 0px" }}>
                <NavLink
                  to="/reports"
                  className={`nav ${!isReportEnabled ? "disabled" : ""}`}
                  activeClassName="isActive"
                  onClick={(e) => {
                    if (!isReportEnabled) {
                      e.preventDefault();
                    } else {
                      handleClick(e);
                    }
                  }}
                >
                  <ReportIcon></ReportIcon>
                  <span className="nav-title">{t("reports")}</span>
                </NavLink>
              </li>
            </>
          )}
          {/* {JSON.parse(storedUser).role !== "user" && (
            <li style={{ padding: "10px 0px" }}>
              <NavLink
                to="/risk"
                className="nav"
                activeClassName="isActive"
                onClick={(e) => handleClick(e)}
              >
                <RisksIcon></RisksIcon>
                <span className="nav-title">{t("risks")}</span>
              </NavLink>
            </li>
          )} */}
          {JSON.parse(storedUser).role === "enterprise_user" && (
            <>
              <li style={{ padding: "10px 0px" }}>
                <NavLink
                  to="/orga_assets"
                  className={`nav ${!isBusinessFunctionEnabled ? "disabled" : ""}`}
                  activeClassName="isActive"
                  onClick={(e) => {
                    if (!isBusinessFunctionEnabled) {
                      e.preventDefault();
                    } else {
                      handleClick(e);
                    }
                  }}
                >
                  <AssetsIcon></AssetsIcon>
                  <span className="nav-title">{t("orga_assets")}</span>
                </NavLink>
              </li>

              <li style={{ padding: "10px 0px" }}>
                <NavLink
                  to="/asset_inventory"
                  className={`nav ${!isDiscoveredAssetsEnabled ? "disabled" : ""}`}
                  activeClassName="isActive"
                  onClick={(e) => {
                    if (!isDiscoveredAssetsEnabled) {
                      e.preventDefault();
                    } else {
                      handleClick(e);
                    }
                  }}
                >
                  <PolicyIcon />
                  <span className="nav-title">{t("discovered_assets")}</span>
                </NavLink>
              </li>
              <li style={{ padding: "10px 0px" }}>
                <NavLink
                  to="/risk-scenarios"
                  className={`nav ${!isRiskScenariosEnabled ? "disabled" : ""}`}
                  activeClassName="isActive"
                  onClick={(e) => {
                    if (!isRiskScenariosEnabled) {
                      e.preventDefault();
                    } else {
                      handleClick(e);
                    }
                  }}
                >
                  <WarningIcon />
                  <span className="nav-title">{t("risk-scenarios")}</span>
                </NavLink>
              </li>
              <li style={{ padding: "10px 0px" }}>
                <NavLink
                  to="/risk-assessment"
                  className={`nav ${!isRiskAssessmentEnabled ? "disabled" : ""}`}
                  activeClassName="isActive"
                  onClick={(e) => {
                    if (!isRiskAssessmentEnabled) {
                      e.preventDefault();
                    } else {
                      handleClick(e);
                    }
                  }}
                >
                  <RemoveModeratorIcon />
                  <span className="nav-title">{t("risk-assessment")}</span>
                </NavLink>
              </li>
              {/* 
              <li style={{ padding: "10px 0px" }}>
                <NavLink
                  to="/asset_inventory"
                  className="nav"
                  activeClassName="isActive"
                  onClick={(e) => handleClick(e)}
                >
                  <RemoveModeratorIcon />
                  <span className="nav-title">{t("evaluation")}</span>
                </NavLink>
              </li> */}
            </>
          )}
          {/* {JSON.parse(storedUser).role !== "user" && (
            <>
              <li style={{ padding: "10px 0px" }}>
                <NavLink
                  to="/weakness"
                  className="nav"
                  activeClassName="isActive"
                  onClick={(e) => handleClick(e)}
                >
                  <WeaknessesIcon></WeaknessesIcon>
                  <span className="nav-title">{t("weaknesses")}</span>
                </NavLink>
              </li>
              <li style={{ padding: "10px 0px" }}>
                <NavLink
                  to="/usecases"
                  className="nav"
                  activeClassName="isActive"
                  onClick={(e) => handleClick(e)}
                >
                  <UseCasesIcon></UseCasesIcon>
                  <span className="nav-title">{t("usecases")}</span>
                </NavLink>
              </li>
            </>
          )} */}
        </ul>
      )}
    </div>
  );
};

export default Sidebar;
